<!-- <app-header></app-header> -->
 <app-new-header></app-new-header>
<div class="not-available-container">
  <div class="not-available-msg">
    <h3>{{ 'not-available.title' | translate }}</h3>
    <p>{{ 'not-available.message' | translate }}</p>
  </div>
  <button mat-button (click)="backToHome()" class="btn-fill-primary btn-size-M">
    {{ 'not-available.back-to-home' | translate }}
  </button>
</div>
